export default {
  "hierarchy": {
    "conditionTags": [
      "multiSelector-conditionTags"
    ],
    "conditionText": [
      "multiSelector-conditionText"
    ],
    "condition": [
      "multiSelector-condition"
    ],
    "test": [
      "multiSelector-test"
    ],
    "conditionSelector": [
      "multiSelector-conditionSelector"
    ],
    "comparator": [
      "multiSelector-comparator"
    ],
    "formInput": [
      "multiSelector-formInput"
    ],
    "attributeFormStringArrayEditor": [
      "multiSelector-formInput",
      "multiSelector-attributeFormStringArrayEditor"
    ],
    "formInputNoPad": [
      "multiSelector-formInputNoPad"
    ]
  },
  "props": {
    "default": {
      "allowAdd": false,
      "selectionType": "tags",
      "checkVariant": "multiSelector|small",
      "popupVariant": "multiSelector|selector",
      "removeButtonVariant": "multiSelector",
      "tagInputVariant": "multiSelector",
      "toggleVariant": "multiSelector|selector"
    },
    "conditionTags": {
      "allowAdd": false,
      "selectionType": "tags",
      "checkVariant": "multiSelector|small",
      "popupVariant": "multiSelector|selector",
      "removeButtonVariant": "multiSelector",
      "tagInputVariant": "multiSelector",
      "toggleVariant": "multiSelector|selector"
    },
    "conditionText": {
      "allowAdd": false,
      "selectionType": "text",
      "checkVariant": "multiSelector|small",
      "popupVariant": "multiSelector|selector",
      "removeButtonVariant": "multiSelector",
      "tagInputVariant": "multiSelector",
      "toggleVariant": "multiSelector|selector"
    },
    "condition": {
      "allowAdd": false,
      "selectionType": "text",
      "checkVariant": "multiSelector|small",
      "popupVariant": "multiSelector|selector",
      "removeButtonVariant": "multiSelector",
      "tagInputVariant": "multiSelector",
      "toggleVariant": "multiSelector|selector"
    },
    "test": {
      "allowAdd": false,
      "selectionType": "tags",
      "checkVariant": "multiSelector|small",
      "popupVariant": "multiSelector|selector",
      "removeButtonVariant": "multiSelector",
      "tagInputVariant": "multiSelector",
      "toggleVariant": "multiSelector|selector"
    },
    "conditionSelector": {
      "allowAdd": true,
      "selectionType": "tags",
      "checkVariant": "multiSelector|small",
      "popupVariant": "multiSelector|selector",
      "removeButtonVariant": "multiSelector",
      "tagInputVariant": "multiSelector",
      "toggleVariant": "multiSelector|selector"
    },
    "comparator": {
      "allowAdd": false,
      "selectionType": "tags",
      "checkVariant": "multiSelector|small",
      "popupVariant": "multiSelector|selector",
      "removeButtonVariant": "multiSelector",
      "tagInputVariant": "multiSelector",
      "toggleVariant": "multiSelector|selector"
    },
    "formInput": {
      "allowAdd": false,
      "selectionType": "tags",
      "checkVariant": "multiSelector|small",
      "popupVariant": "multiSelector|selector",
      "removeButtonVariant": "multiSelector",
      "tagInputVariant": "multiSelector",
      "toggleVariant": "multiSelector|selector"
    },
    "attributeFormStringArrayEditor": {
      "allowAdd": false,
      "selectionType": "tags",
      "checkVariant": "multiSelector|small",
      "popupVariant": "multiSelector|selector",
      "removeButtonVariant": "multiSelector",
      "tagInputVariant": "multiSelector",
      "toggleVariant": "multiSelector|selector"
    },
    "formInputNoPad": {
      "allowAdd": false,
      "selectionType": "tags",
      "checkVariant": "multiSelector|small",
      "popupVariant": "multiSelector|selector",
      "removeButtonVariant": "multiSelector",
      "tagInputVariant": "multiSelector",
      "toggleVariant": "multiSelector|selector"
    }
  }
}